import { Component, inject } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Select} from './select';

@Component({
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    standalone: false
})
export class SelectComponent {
  select = inject<Select<any>>(MAT_DIALOG_DATA);
  dialogRef = inject<MatDialogRef<SelectComponent>>(MatDialogRef);

  selectedId: string;

  constructor() {
    const select = this.select;

    this.selectedId = select.defaultValue?.getId();
  }

  onConfirm(): void {
    const selectedOption = this.select.optionList.find(option => option.getId() === this.selectedId);
    this.dialogRef.close(selectedOption);
  }
}
